import * as KeywordActionTypes from '../../../constants/contents/KeywordActionTypes';

const initialState = {
    searchKeyword: '',
    searchType: 'title',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case KeywordActionTypes.CLEAR_ITEMS:
            return {
                searchKeyword: '',
                searchType: 'title',
            };
        case KeywordActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword,
                searchType: action.searchType,

            });
        default :
            return state;
    }
}
